import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {ErroAPI} from '../../model/geral';

//import { ModalService } from '../../service/modal.service';

@Injectable()
export class UtilApi {

    constructor(/* private modalService: ModalService */) {
    }

    public trataErro(error: any): Observable<ErroAPI> {

        let erroApi = new ErroAPI();

        erroApi.httpStatus = error.status;
        erroApi.httpText = error.statusText;

        let json = error;

        if (json != null) {
            erroApi.erro = json.erro;
            erroApi.mensagem = json.mensagem;
        }

        return Observable.throw(erroApi);
    }

    invocacaoRemotaComRetry(repetitions: number, timeout: number, objeto: any, funcao: () => any): any {
        if (repetitions > 0) {
            try {
                return funcao.call(objeto);
            } catch (error) {
                setTimeout(() => {
                    return this.invocacaoRemotaComRetry(repetitions - 1, timeout, objeto, funcao);
                }, 1000);
            }
        } else {
            //this.modalService.exibirMensagem("Erro!", "Não foi possível carregar os dados", "Fechar");
            return null;
        }
    }

    invocacaoRemotaComCondicao(repetitions: number, timeout: number, objeto: any, funcao: () => any, condicao: boolean): any {
        if (repetitions > 0) {
            try {

                if (condicao) {
                    funcao.call(objeto);

                    setTimeout(() => {
                        return this.invocacaoRemotaComCondicao(repetitions - 1, timeout, objeto, funcao, condicao);
                    }, 1000);
                } else {
                    return;
                }
            } catch (error) {
                setTimeout(() => {
                    return this.invocacaoRemotaComCondicao(repetitions - 1, timeout, objeto, funcao, condicao);
                }, 1000);
            }
        } else {
            //this.modalService.exibirMensagem("Erro!", "Não foi possível carregar os dados", "Fechar");
            return null;
        }
    }

}



// WEBPACK FOOTER //
// ./src/service/api/util.api.ts